export default {"src":"/_next/static/media/Travel.e36fb095.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};